import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { AdminButton } from "../../buttons/versionHistoryBtn";
import '../modal.css';
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { editDistributorDistricts, fetchDistributorDistricts } from "../../../redux/actions/distributorActions";
import ErrorMsg from "../../form/errorMsg";
import UpdatedSuccessfullyPopup from "../../popups/UpdatedSuccessfullyPopup";

const DistrictEditModal = ({ show, handleClose, servingDistricts, distributorID, fetchDistributerDetail }) => {
  const params = useParams()
  const dispatch = useDispatch();
  const [districtsOptions, setDistrictsOptions] = useState([]);
  const [districtsUpdated, setDistrictsUpdated] = useState(false)
  const initialValues = { districts: servingDistricts };
  const validationSchema = Yup.object().shape({});

  useEffect(() => {
    dispatch(fetchDistributorDistricts(params?.id, onGetDistrictSuccess, onGetDistrictError))
  }, []);

  const onGetDistrictSuccess = (data) => {
    let newArr = data.data.data.distributorDistricts.map((ele) => ({
      value: ele?.district?.id,
      label: ele?.district?.name,
    }));
    setDistrictsOptions(newArr)
  }

  const onGetDistrictError = (err) => {
    console.log(err);
  };

  const onSubmit = (values) => {
    values['distributor_id'] = distributorID
    console.log(values);
    dispatch(editDistributorDistricts(values, onSuccess, onError))
  }

  const timeOutFnc = () => {
    setDistrictsUpdated(false)
  }

  const onSuccess = (data) => {
    console.log(data)
    handleClose()
    fetchDistributerDetail()
    setDistrictsUpdated(true)
    setTimeout(timeOutFnc, 2000);
  }
  const onError = (err) => {
    console.log(err);
  }

  return (
    <>
      <Modal centered show={show} onHide={handleClose} dialogClassName="my-modal">
        <ModalBody>
          <div className="p-2">
            <p className="fn_Nunito fw_600 fs_16 color_7065e4 my-2 px-0 border-bottom">
              Edit District
            </p>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {({ setFieldValue, values }) => (
                <div className="mb-3">
                  <label className="color_262c3d fs_14 fw_400 mt-2 mb-2" >District</label>
                  <Form>
                    <Field name="districts">
                      {({ field }) => (
                        <Select
                          isMulti
                          {...field}
                          options={districtsOptions}
                          id="districts"
                          name="districts"
                          styles={customStyles}
                          onChange={(selectedOption) => {
                            setFieldValue(
                              "districts", selectedOption
                              ? selectedOption.map(
                                (item) => item.value
                              )
                              : []
                            );
                          }}
                          placeholder={'Enter your districts'}
                          value={districtsOptions?.filter((d1) =>
                            values?.districts?.some((d2) => d2 == d1.value)
                          )}
                        />

                      )}
                    </Field>
                    <ErrorMsg name="districts" />
                    <div className="d-flex justify-content-end align-items-center gap-3">
                      <button
                        type="submit"
                        className="modal-submit-btn fs_14 text-white py-2 px-4 fw_700"
                        style={{ width: "130px" }}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        onClick={() => handleClose()}
                        className="modal-logout-btn fs_14 fw_700 px-3 py-2"
                        style={{ width: "90px" }}
                      >
                        CLOSE
                      </button>
                    </div>
                  </Form>
                </div>
              )}

            </Formik>
          </div>
        </ModalBody>
      </Modal>
      <UpdatedSuccessfullyPopup show={districtsUpdated} />
    </>
  );
};

export default DistrictEditModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    // height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
}